module.exports = __webpack_public_path__ + "static/media/fish.ff7562e5.png";